import React, { Component, Fragment } from 'react';
import { DefaultButton, IconButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { DetailsList, SelectionMode, Selection, ConstrainMode } from 'office-ui-fabric-react/lib/DetailsList';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import { CommandBar } from 'office-ui-fabric-react/lib/CommandBar';
import { SearchBox } from 'office-ui-fabric-react/lib/SearchBox';
import { MessageBars } from '../Outils/MessageBars';
import { TooltipHost } from 'office-ui-fabric-react/lib/Tooltip';
import { Sticky, StickyPositionType } from 'office-ui-fabric-react/lib/Sticky';
import { Dialog, DialogType, DialogFooter } from 'office-ui-fabric-react/lib/Dialog';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { ScrollablePane, ScrollbarVisibility } from 'office-ui-fabric-react/lib/ScrollablePane';

import { DataDroit } from '../../data/DataDroit.jsx';

import { Immocom } from '../../specifique/immocom';

import { FicheDroit } from '../Fiche/FicheDroit';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { EUIComboBox } from '../EUI/EUIComboBox';
import { ComboBoxTypeMandat } from '../ComboBox/ComboBoxTypeMandat';

/*
***************************************************************
 PROPS:
 
***************************************************************
*/

export class DetailsListDroit extends Component {
    objetState = {
        items: [],
        listDroit: [],
        listTypeMandat: [],

        enCoursDeTraitement: false,
        onAffichePanelDroit: false,
        onAffichePanelFiltre: false,

        recherche: '',
        tri: '',

        hideMessageBarWarning: true,
        hideMessageBarError: true,
        hideMessageBarFiltres: true,
        warningMessage: '',
        errorMessage: '',
        messageMessageBarFiltres: '',
        messageEnCoursTraitement: '',

        onAfficheDialogSuppressionDroit: false,
        idTypeMandatASupprimer: 0,
        idDroitASupprimer: 0,

        // panel filtre
        idTypeMandatFiltered: 0,
        domaineFiltered: '',
        fonctionnaliteFiltered: '',
        actionFiltered: '',
    };

    _creationContent() {
        const { items } = this.state;

        return (
            <DetailsList
                items={items}
                columns={this.columns}
                selectionMode={SelectionMode.none}
                constrainMode={ConstrainMode.unconstrained}
                onColumnHeaderClick={this._onColumnHeaderClick}
                onRenderDetailsHeader={this._onRenderDetailsHeader}
                onRenderItemColumn={this._onRenderItemColumn}
            />
        );
    }

    constructor(props) {
        super(props);

        this.state = this.objetState;

        //#region chargement des columns
        this.columns = [
            {
                key: 'idDroit',
                name: 'IdDroit',
                fieldName: 'idDroit',
                minWidth: 50,
                maxWidth: 50,
                isResizable: true,
                onRender: (item) => {
                    let idDroit = item.idDroit;
                    return <span title={`n°` + idDroit}>{idDroit}</span>;
                }
            },
            {
                key: 'idTypeMandat',
                name: 'IdTypeMandat',
                fieldName: 'idTypeMandat',
                minWidth: 75,
                maxWidth: 100,
                isResizable: true,
                onRender: (item) => {
                    let idTypeMandat = item.idTypeMandat;
                    return <span title={`n°` + idTypeMandat}>{idTypeMandat}</span>;
                }
            },
            {
                key: 'typeMandat',
                name: 'TypeMandat',
                fieldName: 'typeMandat',
                minWidth: 70,
                maxWidth: 150,
                isResizable: true,
                onRender: (item) => {
                    return <span title={item.typeMandat}>{item.typeMandat}</span>;
                }
            },
            {
                key: 'domaine',
                name: 'Domaine',
                fieldName: 'domaine',
                minWidth: 100,
                maxWidth: 120,
                isResizable: true,
                onRender: (item) => {
                    return <span title={item.domaine}>{item.domaine}</span>;
                }
            },
            {
                key: 'fonctionnalite',
                name: 'Fonctionnalite',
                fieldName: 'fonctionnalite',
                minWidth: 150,
                maxWidth: 220,
                isResizable: true,
                onRender: (item) => {
                    return <span title={item.fonctionnalite}>{item.fonctionnalite}</span>;
                }
            },
            {
                key: 'action',
                name: 'Action',
                fieldName: 'action',
                minWidth: 150,
                maxWidth: 220,
                isResizable: true,
                onRender: (item) => {
                    return <span title={item.action}>{item.action}</span>;
                }
            },
            {
                key: 'description',
                name: 'Description',
                fieldName: 'description',
                minWidth: 200,
                maxWidth: 2000,
                isResizable: true,
                onRender: (item) => {
                    return <span title={item.description}>{item.description}</span>;
                }
            },
            {
                key: 'etat',
                name: 'Etat',
                fieldName: 'etat',
                minWidth: 50,
                maxWidth: 50,
                isResizable: true,
                onRender: (item) => {
                    let etat = item.etat;
                    return <span title={etat}>{etat}</span>;
                }
            },
            {
                key: 'delete',
                name: 'Supprimer',
                ariaLabel: 'Supprimer le droit',
                fieldName: 'delete',
                minWidth: 20,
                maxWidth: 20,
                iconName: '',
                isIconOnly: true,
                isSorted: false,
                onRender: (item) => {
                    return <IconButton
                        iconProps={{ iconName: 'Delete' }}
                        title="Supprimer le droit"
                        ariaLabel="Supprimer"
                        onClick={() => this._onAffichageConfirmationSuppressionDroit(item.idTypeMandat, item.idDroit)} />;
                }
            }
        ];
        //#endregion
    }

    _getItems = () => {
        return [
            {
                key: 'search',
                onRender: () => <SearchBox
                    placeholder="Recherche rapide"
                    className="searchBox"
                    onSearch={value => this._onSearchBox(value)}
                    onClear={(e) => this._onSearchBox('')}
                //onBlur={(e) => this._onBlurSearchBox(e.target.value)}
                />
            },
            {
                key: 'nouveauDroit',
                name: 'Nouveau droit',
                iconProps: {
                    iconName: 'Add'
                },
                onClick: () => this._onAffichagePanelDroit()
            }
        ];
    }

    _getFarItems = () => {
        return [
            {
                key: 'nombreEnregistrement',
                name: !this.state.items ? 0 : this.state.items.length
            },
            {
                key: 'filtre',
                name: 'Filtres',
                iconProps: {
                    iconName: 'Filter'
                },
                iconOnly: true,
                disabled: this.state.disableFiltres,
                onClick: () => this._onAffichePanelFiltre()
            }
        ];
    }

    _chargementDonnees() {
        this._afficheLoader('Chargement des droits en cours');

        const { idTypeMandatFiltered, domaineFiltered, fonctionnaliteFiltered, actionFiltered, tri, recherche } = this.state;

        let objet = {
            idTypeMandat: idTypeMandatFiltered,
            domaine: domaineFiltered,
            fonctionnalite: fonctionnaliteFiltered,
            action: actionFiltered,
            recherche,
            tri
        };

        DataDroit._chargementTypeMandatDroit(objet)
            .then(responseFetch => {
                const statePropertiesStatutsPage = Immocom.notifieStatusHttpImmocom(responseFetch, this);
                const pasEnErreur = statePropertiesStatutsPage.hideMessageBarWarning && statePropertiesStatutsPage.hideMessageBarError;

                this.setState({
                    items: pasEnErreur ? responseFetch.reponseAPIobjet : [],
                    ...statePropertiesStatutsPage
                });
            })
            .catch(ex => this._afficheMessageErreur("Une erreur est survenue lors de la récupération des droits de chaque type mandat. " + ex.message))
            .finally(() => this._cacheLoader());
    }

    _chargementDonneesStatiques = () => {
        DataDroit._chargementDroit()
            .then(responseFetch => {
                const statePropertiesStatutsPage = Immocom.notifieStatusHttpImmocom(responseFetch, this);
                const pasEnErreur = statePropertiesStatutsPage.hideMessageBarWarning && statePropertiesStatutsPage.hideMessageBarError;

                this.setState({
                    listDroit: pasEnErreur ? responseFetch.reponseAPIobjet : [],
                    ...statePropertiesStatutsPage
                });
            })
            .catch(ex => this._afficheMessageErreur("Une erreur est survenue lors de la récupération des droits. " + ex.message));

        DataDroit._chargementTypeMandat()
            .then(responseFetch => {
                const statePropertiesStatutsPage = Immocom.notifieStatusHttpImmocom(responseFetch, this);
                const pasEnErreur = statePropertiesStatutsPage.hideMessageBarWarning && statePropertiesStatutsPage.hideMessageBarError;

                this.setState({
                    listTypeMandat: pasEnErreur ? responseFetch.reponseAPIobjet : [],
                    ...statePropertiesStatutsPage
                });
            })
            .catch(ex => this._afficheMessageErreur("Une erreur est survenue lors de la récupération des type mandats. " + ex.message));

    }

    _onSuppressionDroit = () => {
        this._onCacheConfirmationSuppressionDroit();

        const { idTypeMandatASupprimer, idDroitASupprimer } = this.state;

        if (!idTypeMandatASupprimer) {
            this._afficheMessageErreur("idTypeMandatASupprimer non défini");
            return;
        }

        if (!idDroitASupprimer) {
            this._afficheMessageErreur("idDroitASupprimer non défini");
            return;
        }

        this._afficheLoader('Suppression du droit en cours');

        // Suppress droit
        DataDroit._suppressionTypeMandatDroit({ idTypeMandat: idTypeMandatASupprimer, idDroit: idDroitASupprimer })
            .then((responseFetch) => {
                const statePropertiesStatutsPage = Immocom.notifieStatusHttpImmocom(responseFetch, this);
                this.setState({ ...statePropertiesStatutsPage }, this._chargementDonnees);
            })
            .catch(ex => this._afficheMessageErreur(ex.message))
            .finally(() => this._cacheLoader())
    }

    _onAffichageConfirmationSuppressionDroit = (idTypeMandat, idDroit) => {
        this.setState({
            idTypeMandatASupprimer: idTypeMandat,
            idDroitASupprimer: idDroit,
            onAfficheDialogSuppressionDroit: true
        })
    }

    _onCacheConfirmationSuppressionDroit = () => {
        this.setState({
            idTypeMandatASupprimer: 0,
            idDroitASupprimer: 0,
            onAfficheDialogSuppressionDroit: false
        })
    }

    _onAffichagePanelDroit = () => {
        this.setState({
            onAffichePanelDroit: true
        });
    };

    _onAffichePanelFiltre = () => {
        this.setState({
            onAffichePanelFiltre: true,
            onAffichePanelDroit: false
        });
    };

    _onCachePanelDroitEtRechargementDesDonnees = () => {
        this.setState({
            onAffichePanelDroit: false
        }, this._chargementDonnees);
    };

    _onCachePanelFiltre = () => {
        this.setState({ onAffichePanelFiltre: false });
    };

    _onSearchBox = (text) => {
        this.setState({
            recherche: text,
            pageIndex: 1
        }, this._chargementDonnees);
    };

    _onFiltreTableau = () => {
        this.setState(
            { pageIndex: 1 },
            this._chargementDonnees
        );
        this._onCachePanelFiltre();
    };

    _reinitFiltre = () => {
        this.setState(this.objetState, () => {
            this._chargementDonnees();
            this._chargementDonneesStatiques()
        });
    }

    _onColumnHeaderClick = (ev, column) => {
        const columns = this.columns;
        const newColumns = columns.slice();
        const currColumn = newColumns.filter(currCol => column.key === currCol.key)[0];

        newColumns.forEach((newCol) => {
            if (newCol === currColumn) {
                currColumn.isSortedDescending = !currColumn.isSortedDescending;
                currColumn.isSorted = true;
            } else {
                newCol.isSorted = false;
                newCol.isSortedDescending = false;
            }
        });

        let tri = column.key + ' ' + (column.isSortedDescending ? 'DESC' : 'ASC');

        this.setState(
            { tri, pageIndex: 1 },
            this._chargementDonnees
        );
    }

    _onRenderDetailsHeader(props, defaultRender) {
        return (
            <Sticky stickyPosition={StickyPositionType.Header} isScrollSynced={true}>
                {defaultRender({
                    ...props,
                    onRenderColumnHeaderTooltip: (tooltipHostProps) => <TooltipHost {...tooltipHostProps} />
                })}
            </Sticky>
        );
    }

    _onRenderFooterFiltresContent = () => {
        return (
            <div>
                <PrimaryButton onClick={this._onFiltreTableau} className="marginRight8px">Valider</PrimaryButton>
                <DefaultButton onClick={this._onCachePanelFiltre}>Fermer</DefaultButton>
            </div>
        );
    };

    _afficheLoader = (message) => this.setState({
        enCoursDeTraitement: true,
        messageEnCoursTraitement: message
    });

    _cacheLoader = () => this.setState({
        enCoursDeTraitement: false,
        messageEnCoursTraitement: ''
    });

    _afficheMessageErreur = (message) => this.setState({
        hideMessageBarError: false,
        errorMessage: message
    });

    _cacheMessageErreur = () => this.setState({
        hideMessageBarError: true,
        errorMessage: ''
    });

    _afficheMessageAvertissement = (message) => this.setState({
        hideMessageBarError: false,
        errorMessage: message
    });

    _cacheMessageAvertissement = () => this.setState({
        hideMessageBarError: true,
        errorMessage: ''
    });

    _onChangeDomaine = (item) => {
        if (!item || !item.key) {
            return;
        }

        this.setState({ domaineFiltered: item.key, fonctionnaliteFiltered: '', actionFiltered: '' });
    }

    _onChangeFonctionnalite = (item) => {
        if (!item || !item.key) {
            return;
        }

        this.setState({ fonctionnaliteFiltered: item.key, actionFiltered: '' });
    }

    _onChangeAction = (item) => {
        if (!item || !item.key) {
            return;
        }

        this.setState({ actionFiltered: item.key });
    }

    _onChangeTypeMandat = (item) => {
        if (!item || !item.key) {
            return;
        }

        this.setState({ idTypeMandatFiltered: item.key });
    }

    componentDidMount() {
        this._chargementDonnees();
        this._chargementDonneesStatiques();
    }

    render = () => {

        const content = this._creationContent();

        const optionsTypeMandat = this.state.listTypeMandat.map(item => ({ key: item.idTypeMandat, text: item.typeMandat }));

        const optionsDomaine = this.state.listDroit.reduce((acc, droit) => {
            const dejaAjoute = acc.some(opt => opt.key === droit.domaine);

            if (!dejaAjoute)
                acc.push({ key: droit.domaine, text: droit.domaine });

            return acc;
        }, []);

        var domaineFiltered = this.state.domaineFiltered;
        var listDroitFiltree = this.state.listDroit.filter(droit => (domaineFiltered == '' ? 1 == 1 : droit.domaine === domaineFiltered));
        const optionsFonctionnalite = listDroitFiltree.reduce((acc, droit) => {
            const dejaAjoute = acc.some(opt => opt.key === droit.fonctionnalite);

            if (!dejaAjoute)
                acc.push({ key: droit.fonctionnalite, text: droit.fonctionnalite });

            return acc;
        }, []);

        var fonctionnaliteFiltered = this.state.fonctionnaliteFiltered;
        listDroitFiltree = listDroitFiltree.filter(droit => (fonctionnaliteFiltered == '' ? 1 == 1 : droit.fonctionnalite === fonctionnaliteFiltered));
        const optionsAction = listDroitFiltree.reduce((acc, droit) => {
            const dejaAjoute = acc.some(opt => opt.key === droit.action);

            if (!dejaAjoute)
                acc.push({ key: droit.action, text: droit.action });

            return acc;
        }, []);

        return <Fragment>

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            <Stack verticalFill>
                <CommandBar
                    items={this._getItems()}
                    overflowButtonProps={{ ariaLabel: 'Plus de fonctionnalités' }}
                    farItems={this._getFarItems()}
                    ariaLabel={'Utiliser les flèches droite et gauche pour naviguer'}
                />
                <MessageBars
                    errorMessage={this.state.errorMessage}
                    infoMessage={this.state.messageMessageBarFiltres}
                    warningMessage={this.state.warningMessage}
                    onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                    onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                />
                <div className="position-relative h-100">
                    <ScrollablePane scrollbarVisibility={ScrollbarVisibility.auto}>
                        {content}
                    </ScrollablePane>

                </div>
            </Stack>

            <Panel
                isOpen={this.state.onAffichePanelFiltre}
                type={PanelType.smallFixedFar}
                onDismiss={this._onCachePanelFiltre}
                headerText="Filtres"
                closeButtonAriaLabel="Close"
                onRenderFooterContent={this._onRenderFooterFiltresContent}
            >
                <div className="buttonFiltres">
                    <IconButton
                        iconProps={{ iconName: 'ClearFilter' }}
                        className="buttonFiltres"
                        title="Réinitialiser les filtres"
                        ariaLabel="Filtres"
                        onClick={() => this._reinitFiltre()}
                    />
                </div>
                <ComboBoxTypeMandat
                    inclureAdministrateur
                    inclureCallCenter
                    inclureCommercialisateur
                    inclureControleDeGestionNational
                    inclureEbook
                    inclureMaisonIndividuelle
                    inclureModuleExterne
                    inclurePrimPromo
                    inclureWebServices
                    onChange={(event, option) => this._onChangeTypeMandat(option)}
                    selectedKey={this.state.idTypeMandatFiltered}
                />
                <EUIComboBox
                    label="Domaine"
                    onChange={(event, option) => this._onChangeDomaine(option)}
                    options={optionsDomaine}
                    placeholder="Domaine"
                    selectedKey={this.state.domaineFiltered}
                />
                <EUIComboBox
                    label="Fonctionnalité"
                    onChange={(event, option) => this._onChangeFonctionnalite(option)}
                    options={optionsFonctionnalite}
                    placeholder="Fonctionnalité"
                    selectedKey={this.state.fonctionnaliteFiltered}
                />
                <EUIComboBox
                    label="Action"
                    onChange={(event, option) => this._onChangeAction(option)}
                    options={optionsAction}
                    placeholder="Action"
                    selectedKey={this.state.actionFiltered}
                />
            </Panel>

            <FicheDroit
                estMontre={this.state.onAffichePanelDroit}
                onAnnuleFiche={() => this._onCachePanelDroitEtRechargementDesDonnees()}
                onEnregistrementFiche={() => this._onCachePanelDroitEtRechargementDesDonnees()}
                listDroit={this.state.listDroit}
                listTypeMandat={this.state.listTypeMandat}
                listTypeMandatDroit={this.state.items}
            />

            <Dialog
                hidden={!this.state.onAfficheDialogSuppressionDroit}
                onDismiss={this._onCacheDialogSuppressionDroit}
                dialogContentProps={{
                    type: DialogType.normal,
                    title: 'Suppression du droit',
                    subText: 'Attention, vous êtes en train de supprimer un droit affecté à un type de mandat, souhaitez-vous continuer ?'
                }}
                modalProps={{
                    isBlocking: true,
                    styles: { main: { maxWidth: 450 } }
                }}
            >
                <DialogFooter>
                    <PrimaryButton onClick={this._onSuppressionDroit} text="Supprimer" />
                    <DefaultButton onClick={this._onCacheDialogSuppressionDroit} text="Annuler" />
                </DialogFooter>
            </Dialog>

        </Fragment>;
    }
}